import { render } from "./AppTableButtonColumn.vue?vue&type=template&id=071f4a64&scoped=true"
import script from "./AppTableButtonColumn.vue?vue&type=script&lang=js"
export * from "./AppTableButtonColumn.vue?vue&type=script&lang=js"

import "./AppTableButtonColumn.vue?vue&type=style&index=0&id=071f4a64&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071f4a64"]])

export default __exports__